export const getFirstLetterInUpperCase = (value: string): string =>
  value.charAt(0).toUpperCase()
